import session from 'lib/api/links/session';
import { APP_GALLERY_URL } from 'lib/appConfig';

// fetch has no timeout of its own; a gallery that accepts the connection and never answers
// would otherwise hold the lookup, and the operator screen behind it, open forever.
export const GALLERY_TIMEOUT_MS = 8000;

// One registered view. A 404 is the gallery's answer for both "deleted" and "not visible to this
// company", and is returned as null; any other failure throws. The gallery verifies the
// Dashboard user token itself; the opaque session key is scoped to operator routes only.
export const fetchGalleryApp = async (appRef) => {
  if (!APP_GALLERY_URL) {
    return null;
  }
  const token = await session.getJwt();
  if (!token) {
    throw new Error('app gallery: no user token');
  }
  // The timer stays armed until the body is read: a gallery that sends headers and then stalls the
  // body would otherwise escape the timeout.
  const controller = new AbortController();
  const timer = setTimeout(() => {
    return controller.abort();
  }, GALLERY_TIMEOUT_MS);
  try {
    const res = await fetch(
      `${APP_GALLERY_URL}/apps/${encodeURIComponent(appRef)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      }
    );
    if (res.status === 404) {
      return null;
    }
    if (!res.ok) {
      throw new Error(`app gallery: HTTP ${res.status}`);
    }
    return await res.json();
  } finally {
    clearTimeout(timer);
  }
};

export default fetchGalleryApp;
